import { useId } from 'react';
import { INTERNAL_FREIGHT, MAX_REBILL_REFERENCE_LENGTH } from './rebill-freight';

/**
 * Rebill freight for a Cargonizer booking: pick a project number or
 * "Intern frakt", or type one that isn't listed (tidaltech/koi#8233).
 */
export function RebillFreightField({
  value,
  onChange,
  options,
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  options: readonly string[];
  disabled?: boolean;
}) {
  const id = useId();
  return (
    <label>
      Rebill freight
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        list={`${id}-options`}
        required
        maxLength={MAX_REBILL_REFERENCE_LENGTH}
        autoComplete="off"
        placeholder={`Choose a project number or ${INTERNAL_FREIGHT}`}
        disabled={disabled}
        aria-describedby={`${id}-hint`}
      />
      <datalist id={`${id}-options`}>
        {options.map((option) => (
          <option key={option} value={option} />
        ))}
      </datalist>
      <span className="drawer-version-note" id={`${id}-hint`}>
        The project number to rebill the freight to (e.g. BDO), or “{INTERNAL_FREIGHT}” if the
        customer isn’t billed. Sent to Cargonizer as the sender’s reference for X-Ledger.
      </span>
    </label>
  );
}
